import { c as _c } from "react/compiler-runtime";
import { HeroImage } from '../../GiftDetailHeader/_components/HeroImage';
interface MobileHeroProps {
  heroImageUrlList: string[];
  adultYN: boolean;
  thumbnailSrc?: string;
}
export const MobileHero = t0 => {
  const $ = _c(4);
  const {
    heroImageUrlList,
    adultYN,
    thumbnailSrc
  } = t0;
  let t1;
  if ($[0] !== adultYN || $[1] !== heroImageUrlList || $[2] !== thumbnailSrc) {
    t1 = <div className="hidden mobile:block tablet:block"><HeroImage heroImageUrlList={heroImageUrlList} adultYN={adultYN} thumbnailSrc={thumbnailSrc} /></div>;
    $[0] = adultYN;
    $[1] = heroImageUrlList;
    $[2] = thumbnailSrc;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};